module.exports = __webpack_public_path__ + "static/logo-dark-bebb78b76999eabc51e128853f382e79.png";